jQuery( function ( $ ) {
    $( 'a[href^=#]' ).on( 'click', function () {
        const speed = 500; // スクロール速度(ミリ秒)
        const href = $( this ).attr( "href" );
        const target = $( href == "#" || href == "" ? 'html' : href );
        const position = target.offset().top;
        $( 'html' ).animate( { scrollTop:position }, speed, 'swing' );
        return false;
    } );
} );